import Vue from 'vue';
// WebSocket-specific store module
export class WebSocketStore {
    state = Vue.observable({
        connected: false,
        connecting: false,
        messages: [],
        error: null,
        reconnectAttempts: 0,
        maxReconnectAttempts: 5,
        reconnectDelay: 1000,
        lastMessageTime: null
    });
    // Getters
    get connected() {
        return this.state.connected;
    }
    get connecting() {
        return this.state.connecting;
    }
    get messages() {
        return this.state.messages;
    }
    get error() {
        return this.state.error;
    }
    get reconnectAttempts() {
        return this.state.reconnectAttempts;
    }
    get maxReconnectAttempts() {
        return this.state.maxReconnectAttempts;
    }
    get reconnectDelay() {
        return this.state.reconnectDelay;
    }
    get lastMessageTime() {
        return this.state.lastMessageTime;
    }
    get canReconnect() {
        return this.state.reconnectAttempts < this.state.maxReconnectAttempts;
    }
    // Actions
    setConnected(connected) {
        this.state.connected = connected;
        if (connected) {
            this.state.connecting = false;
            this.state.error = null;
            this.state.reconnectAttempts = 0;
        }
    }
    setConnecting(connecting) {
        this.state.connecting = connecting;
    }
    setError(error) {
        this.state.error = error;
        this.state.connecting = false;
    }
    addMessage(message) {
        this.state.messages.push(message);
        this.state.lastMessageTime = new Date();
    }
    incrementReconnectAttempts() {
        this.state.reconnectAttempts++;
    }
    resetReconnectAttempts() {
        this.state.reconnectAttempts = 0;
    }
    setReconnectDelay(delay) {
        this.state.reconnectDelay = delay;
    }
    clearMessages() {
        this.state.messages = [];
    }
    clearError() {
        this.state.error = null;
    }
    clearAll() {
        this.state.connected = false;
        this.state.connecting = false;
        this.state.messages = [];
        this.state.error = null;
        this.state.reconnectAttempts = 0;
        this.state.lastMessageTime = null;
    }
}
// Export singleton instance
export const websocketStore = new WebSocketStore();
